/* import __COLOCATED_TEMPLATE__ from './sh-search-field.hbs'; */
import $ from 'jquery';
import { scheduleOnce } from '@ember/runloop';
import { alias } from '@ember/object/computed';
import { computed, observer, action } from '@ember/object';
import Component from '@ember/component';
import stateManager from '../mixins/state-manager-mixin';

export default Component.extend( stateManager, {

  classNames: ['search-field-container'],
  classNameBindings: [
    'hasCloseButton:has-close-button',
    'hasToggleButton:has-toggle-button',
    'searchEnabledToggle:search-enabled'
  ],

  hasCloseButton: false,
  hasToggleButton: false,

  inputTabindex: computed('tabindex', 'hasToggleButton', 'searchEnabledToggle', function() {
    let tabindex = this.get('tabindex');
    let tabindexString = (typeof tabindex !== 'undefined') ? tabindex.toString() : false;
    let isToggled = this.get('searchEnabledToggle');

    let hasToggleButton = this.get('hasToggleButton');

    // If tabindex is set to -1, just set everything to -1
    if(tabindexString === '-1') {
      return '-1';
    }

    // If we have a toggleButton and we're not toggled, we want to make sure
    // we cant "tab" into the input before the button was pressed
    if(hasToggleButton && !isToggled) {
      return '-1';
    } else if(hasToggleButton && !tabindexString) {
      return tabindex;
    } else if(hasToggleButton) {
      return (parseInt(tabindex) + 1).toString();
    } else {
      return tabindex;
    }
  }),

  closeButtonTabindex: computed('tabindex', function() {
    let tabindex = this.get('tabindex');
    let tabindexString = (typeof tabindex !== 'undefined') ? tabindex.toString() : false;

    // If tabindex is set to -1, just set everything to -1
    if(tabindexString === '-1') {
      return '-1';
    } else if(tabindexString) {
      return (parseInt(tabindex) + 1).toString();
    } else {
      return tabindex;
    }
  }),

  toggleButtonTabindex: alias('tabindex'),


  closeButtonCallback: undefined, // intended to be passed as additional functionality on close button click
  toggleButtonCallback: undefined, // intended to be passed as additional functionality on toggle button click

  searchEnabledToggle: false, // intended to switch between enabled/disabled states when a toggle button is present
  value: undefined, // tracks the current value of the input (user search criteria)

  parentsToNotify: undefined, // an optional selector to use with $().parents() that will attach "active/has-text/search-enabled" classes to whatever's provided
  notifyClassPrefix: undefined, // an optional prefix for the parent classes, so you can identify *what* is actually active/has-text/search-enabled.

  // States
  isLoadingSearchResults: undefined,
  inputHasText: undefined,
  inputActive: undefined,

  // State Service Update Properties
  stateServiceProperties: 'inputHasText, inputActive, searchEnabledToggle',

  watchValue: observer('value', function() {
    let value = this.get('value');
    let parentsToNotifyJQ = this.get('parentsToNotifyJQ');

    let hasTextClass = 'has-text';
    let notifyClass = this._getNotifyClass(hasTextClass);

    let shouldToggle = value.length > 0;

    if(this.get('inputHasText') !== shouldToggle) {
      this.set('inputHasText', shouldToggle);
    }

    $(this.element).find('label').toggleClass(hasTextClass, shouldToggle);

    if(parentsToNotifyJQ) {
      parentsToNotifyJQ.toggleClass(notifyClass, shouldToggle);
    }
  }),

  closeButtonAction: action(function() {
    // Perform any additional passed-in functionality
    if(typeof this.closeButtonCallback === 'function') {
      this.closeButtonCallback();
    }

    this.set('value', '');
  }),

  actions: {
    toggleButtonAction: function() {

      let isToggled = this.get('searchEnabledToggle');

      let searchEnabledClass = 'search-enabled';
      let notifyClass = this._getNotifyClass(searchEnabledClass);

      // Keep any parents notified of toggled search state
      let parentsToNotifyJQ = this.get('parentsToNotifyJQ');

      if(parentsToNotifyJQ) {
        let shouldToggle = !isToggled;

        parentsToNotifyJQ.toggleClass(notifyClass, shouldToggle);
      }

      // If search is currently toggled, we're effectively in a "close-button" state, so
      // we want to invoke that action on click.
      if(isToggled) {
        this.closeButtonAction();
      }

      // Perform any addtional passed-in functionality, and provide state
      if(typeof this.get('toggleButtonCallback') === 'function') {
        this.get('toggleButtonCallback')(isToggled);
      }

      // Adjust locally (bound to css class on container)
      this.toggleProperty('searchEnabledToggle');
    }
  },


  init() {
    this._super(...arguments);

    this.set('_getNotifyClass', this.get('_getNotifyClass').bind(this));

    scheduleOnce('afterRender', this, function() {
      let self = this;
      let input = $(this.element).find('input');

      let activeClass = 'active';
      let notifyClass = this._getNotifyClass(activeClass);

      let parentsToNotify = this.get('parentsToNotify');
      let parentsToNotifyJQ = (typeof parentsToNotify === 'string') ? $(this.element).parents(parentsToNotify) : undefined;


      this.set('parentsToNotifyJQ', parentsToNotifyJQ);

      input.on('focus', function(e) {
        self.set('inputActive', true);
        $(this).parents('label').toggleClass(activeClass, true);
        if(parentsToNotifyJQ) {
          parentsToNotifyJQ.toggleClass(notifyClass, true);
        }
      });

      input.on('blur', function(e) {
        self.set('inputActive', false);
        $(this).parents('label').toggleClass(activeClass, false);
        if(parentsToNotifyJQ) {
          parentsToNotifyJQ.toggleClass(notifyClass, false);
        }
      });
    });

  },

  _getNotifyClass(suffix) {
    let notifyClassPrefix = this.get('notifyClassPrefix');
    let notifyClass = (typeof notifyClassPrefix === 'string') ? `${notifyClassPrefix}-${suffix}` : suffix;
    return notifyClass;
  },


});
